export function fnum(n) {
  var d = ",",
  t = "\u00a0",
  s = n < 0 ? "-" : "",
  i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(2),10)),
  j = i.length > 3 ? i.length % 3 : 0;
  const result = s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + d + Math.abs(n - i).toFixed(2).slice(2);
  return result.slice(-3) === ',00' ? result.slice(0, -3) : result;
}

export function sortOpts(a, b) {
    if(a.label < b.label)
      return -1
  if(a.label > b.label)
      return 1
  if(a.value < b.value)
      return -1
  if(a.value > b.value)
      return 1
  return 0
}

export function getParam(name) {
  let params = new URLSearchParams(window.location.search.slice(1));
  return params.get(name);
}

export function getChanges(data, oldD) {
  let result = {};
  for (let prop in data) {
    if (data.hasOwnProperty(prop) && (data[prop] !== oldD[prop])) {
      result[prop] = data[prop];
    }
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/utils/utils.js